//#region src/utils/matchers/matchers.ts
var NON_NAME_CHARS = /[!#$%&*+/=?^_{|}()~\-@]+/g;
var NAMES_PATTERN = /^[\p{L}\s'.-]+$/u;
var DE_PREFIX_PATTERN = /^\s*de\s+/i;
var isNullOrUndefined = (value) => {
	return value === null || value === void 0;
};
var isEmpty = (value) => {
	if (typeof value === "string") return value.trim() === "";
	if (isNullOrUndefined(value)) return true;
	if (Array.isArray(value) && value.length === 0) return true;
	if (value === false) return true;
	if (typeof value === "object" && Object.keys(value).length === 0) return true;
	if (value === 0) return true;
	return false;
};
var isAlphanumeric = (value) => {
	return !isEmpty(value) ? value?.replace(/[a-zA-Z0-9]+/gi, "") === "" : false;
};
var isMatchOf = (value, pattern) => {
	return !isEmpty(value) && value?.match(pattern) !== null;
};
var containsInvalidNameSymbol = (value) => {
	return isMatchOf(value, /[!#$%&*+/=?^_{|}()~@,]+/g);
};
var containsSymbol = (value) => {
	return isMatchOf(value, /[!#$%&*+/=?^_{|}()~\-@]+/g);
};
var isAddressValid = (value) => {
	return isMatchOf(value, /[!#$%&*+/=?^_{|}()~@]+/g);
};
var isGtPhoneNumberValid = (value) => {
	return isMatchOf(value, /^(\+502\s?)?\d{3}-\d{5}$/);
};
var isOfLength = (value, length) => {
	return isMatchOf(value, /^\d+$/) && (value?.length ?? 0) === length;
};
var isEmailValid = (value) => {
	return isMatchOf(value, /[a-zA-Z0-9+.%_\-%]+@[a-zA-Z0-9][a-zA-Z0-9-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9-]{0,25})+/);
};
var isTaxIdValid = (value) => {
	const specialValues = [
		"CF",
		"cf",
		"C/F",
		"c/f"
	];
	const nitRegex = /^(\d+)-?([\dkK])$/;
	if (!value) return false;
	if (specialValues.includes(value)) return true;
	return isMatchOf(value, nitRegex);
};
var matchesNamesPattern = (value) => {
	return typeof value === "string" && NAMES_PATTERN.test(value);
};
var startsWithDePrefix = (value) => {
	return typeof value === "string" && DE_PREFIX_PATTERN.test(value);
};
var containsDigits = (value) => {
	return isMatchOf(value, /\d/);
};
//#endregion
export { DE_PREFIX_PATTERN, NAMES_PATTERN, NON_NAME_CHARS, containsDigits, containsInvalidNameSymbol, containsSymbol, isAddressValid, isAlphanumeric, isEmailValid, isEmpty, isGtPhoneNumberValid, isMatchOf, isNullOrUndefined, isOfLength, isTaxIdValid, matchesNamesPattern, startsWithDePrefix };

//# sourceMappingURL=matchers.js.map